import { clampUInt } from "../../../Common/IntRangeUtils";
import { ILocalizer } from "../Engine/Core/Localization/ILocalizer";

export const splitLastOccurrence = (source: string, substring: string): [string, string] => {
    const lastIndex = source.lastIndexOf(substring);
    let before = "";
    let after = "";
    if (lastIndex !== -1) {
        before = source.slice(0, lastIndex);
        after = source.slice(lastIndex + 1);
    }
    return [before, after];
};

export const splitHighlightedParts = (text: string, search: string): Array<{ text: string; highlighted: boolean }> => {
    if (!search.trim()) {
        return [{ text: text, highlighted: false }];
    }

    const regex = new RegExp(`(${search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");

    return text
        .split(regex)
        .filter(Boolean)
        .map(part => ({
            text: part,
            highlighted: part.toLowerCase() === search.toLowerCase(),
        }));
};

export const pluralize = (
    count: number,
    words: readonly [string, string, string],
    localizer?: ILocalizer,
    hideNumber?: boolean
): string => {
    const cases = [2, 0, 1, 1, 1, 2] as const;
    const x: 0 | 1 | 2 = count % 100 > 4 && count % 100 < 20 ? 2 : cases[clampUInt(count % 10, 0, 5)];
    return `${hideNumber ? `` : `${count.toString()} `}${localizer ? localizer.translate(words[x]) : words[x]}`;
};

export const HelperFunctionsStringHelpers = {
    pluralize: pluralize,
};
